module.exports = __webpack_public_path__ + "img/icon-yunying.541d11c7.png";